import { render, staticRenderFns } from "./NullPage.vue?vue&type=template&id=7b6c07e8&"
import script from "./NullPage.vue?vue&type=script&lang=js&"
export * from "./NullPage.vue?vue&type=script&lang=js&"
import style0 from "./NullPage.vue?vue&type=style&index=0&id=7b6c07e8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports